module.exports = "<a title=\"La nómina requiere ser financiada\"\r\n    ng-click=\"$ctrl.confirmar = true\">\r\n  <i class=\"fa fa-fw fa-2x fa-circle-o\"></i>\r\n</a>\r\n<nomina-financiamiento-financiar-confirmar\r\n    ng-if=\"$ctrl.confirmar === true\"\r\n    on-close=\"$ctrl.financiar($event.data)\"></nomina-financiamiento-financiar-confirmar>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/financiamiento/financiar/template.html
// module id = 1319
// module chunks = 0